import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { JsonLoaderService } from './json-loader.service';
import { ChatMessageSystem } from '../constants/constants';
import { whitelabelDTO } from '../models/whitelabel';


@Injectable({
  providedIn: 'root'
})

export class WhitelabelService {
  currentWhitelabel = 'Direct call';
  jsonData: any = [];
  jsonSubscription: Subscription | null = null;
  currentWhitelabelAppName: string | undefined = 'Direct call';
  whitelabelList: Array<whitelabelDTO> = [];

  private currentWhitelabelSubject = new Subject<string>();
  currentWhitelabelObservable = this.currentWhitelabelSubject.asObservable();

  private whitelabelInitialMessage: string = '';
  private whitelabelUploadFileSingleRequest: boolean = true; 


  constructor(private jsonLoaderService: JsonLoaderService) { }

  initService(): void {
    const jsonUrl = '/assets/whitelabels/whitelabels.json';
    this.jsonSubscription = this.jsonLoaderService.getJsonData(jsonUrl)
      .subscribe({
        next: (data) => {
          this.jsonData = data;
          this.identifyWhitelabel();
        },
        error: (error) => {
          console.log('Error al leer el JSON:', error);
        }
      });
  }

  ngOnDestroy(): void {
    if (this.jsonSubscription) {
      this.jsonSubscription.unsubscribe();
    }
  }

  identifyWhitelabel() {
    const url = this.getCurrentURL();
    let keys: string[] = url.split('.');
    if (this.currentWhitelabel.length > 0) keys.push(this.currentWhitelabel);

    let keysfake: string[] = 'cadena.separada.4244.por.puntos.para.pruebas'.split('.');
    if (keys.length >= 0) { this.setVariablesValues(keys); }
  }

  getCurrentURL() {
    return window.location.host;
  }

  getCurrentAppName() {
    return this.currentWhitelabelAppName;
  }

  getCurretWhitelabelName(): string {
    return this.currentWhitelabel;
  }

  changefavicon(name: string): void {
    let favIcon: HTMLLinkElement | null = document.querySelector('#favIcon');
    if (favIcon != null) favIcon.href = `assets/whitelabels/${name}/favicon.ico`;
  }

  setVariablesValues(keys: string[]): void {
    this.whitelabelList = <Array<whitelabelDTO>>this.jsonData;
    for (let i = 0; i < this.whitelabelList.length; i++) {
      if (keys.indexOf(this.whitelabelList[i].name) != -1) {
        this.currentWhitelabel = this.whitelabelList[i].name;
        if (this.whitelabelList[i].appName != null) { this.currentWhitelabelAppName = this.whitelabelList[i].appName };

        this.changefavicon(this.currentWhitelabel);

        if (this.whitelabelList[i].styles != undefined) {
          this.whitelabelList[i].styles?.forEach(data => {
            document.documentElement.style.setProperty(data.var, data.value);
          });
        }

        this.whitelabelInitialMessage = this.whitelabelList[i].chat?.initialMessage ?? ChatMessageSystem.INITIAL_MESSAGE;
        this.whitelabelUploadFileSingleRequest = this.whitelabelList[i].uploadFileSingleRequest;

        this.currentWhitelabelSubject.next(this.currentWhitelabel);
        return;
      }
      else {
        console.log('El estilo no existe');
      }
    }
  }

  getChatInitialMessage(): string {
    return this.whitelabelInitialMessage;
  }

  getUploadFileSingleRequest(): boolean {
    return this.whitelabelUploadFileSingleRequest;
  }

}


